import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import {computed, nextTick, onMounted, ref, watch} from "vue";
import {ContextMenuExposeInterface, ContextMenuItemInterface} from "~/core-ui/vue/ui/context-menu/ContextMenuInterface";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import {__} from "~/ts/library/Translate";
import toggleClientPin from "~/operatorApplication/ts/service/buddyList/toggleClientPin";
import toggleClientMute from "~/operatorApplication/ts/service/buddyList/toggleClientMute";
import markClientAsUnreaded from "~/operatorApplication/ts/service/buddyList/markClientAsUnreaded";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import OperatorApplicationBuddyList from "~/operatorApplication/ts/service/OperatorApplicationBuddyList";
import ContextMenu from "~/core-ui/vue/ui/context-menu/ContextMenu.vue";
import OperatorApplicationMarkClientAsHaveNoAnswerDialog
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/OperatorApplicationMarkClientAsHaveNoAnswerDialog.vue";
import AdditionalClientInfoDialog
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/AdditionalClientInfoDialog.vue";
import OperatorClientHistoryPreviewDialog
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/OperatorClientHistoryPreviewDialog.vue";
import CoreUiChatHistoryHelper from "~/core-ui/vue/chat/CoreUiChatHistoryHelper";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "BuddyListItemContextMenu"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    buddyList: {},
    username: {},
    event: {},
    anotherOperatorBuddyList: {}
  }, {
    "visible": { type: Boolean },
    "visibleModifiers": {},
  }),
  emits: ["update:visible"],
  setup(__props: any) {

let props = __props;

let visible = _useModel<boolean>(__props, "visible")

let contextMenuRef = ref<ContextMenuExposeInterface>();

let markAsOfflineDialog = ref<{
    visible: boolean,
    client: OperatorApplicationApi.OperatorApplicationClientOpenApiModel
}>();

let previewDialog = ref<{
    visible: boolean,
    client: OperatorApplicationApi.OperatorApplicationClientOpenApiModel
}>();


let clientInfoDialog = ref<{
    visible: boolean,
    client: OperatorApplicationApi.OperatorApplicationClientOpenApiModel,
    pages?: boolean
}>();

function openMarkAsOfflineDialog(client: OperatorApplicationApi.OperatorApplicationClientOpenApiModel) {
    markAsOfflineDialog.value = {
        visible: true,
        client
    };
}

function openPreviewDialog(client: OperatorApplicationApi.OperatorApplicationClientOpenApiModel) {
    previewDialog.value = {
        visible: true,
        client
    };
}

function openAdditionalClientInfoDialog(client: OperatorApplicationApi.OperatorApplicationClientOpenApiModel, pages?: boolean) {
    if (!OperatorAccountStore.showFreeDialogForSite(client.siteId)) {
        clientInfoDialog.value = {
            visible: true,
            client,
            pages
        };
    }
}



function openContextMenu() {
    if (visible.value) {
        let userdata = ClientUserdataStore.getByUsername(props.username, false);
        if (userdata) {
            let menu: ContextMenuItemInterface[] = [
                {
                    text: userdata.isPinned ? __("Открепить") : __('Закрепить'),
                    onClick: () => toggleClientPin(userdata),
                    icon: userdata.isPinned ? "thumbtack-slash" : "thumbtack"
                }
            ];
            if (OperatorAccountStore.checkAccess(OperatorAccountStore.data.value.accessRights.canToggleMute, userdata.siteId)) {
                menu.push({
                    text: userdata.isMuted ? __('Включить уведомления') : __('Отключить уведомления'),
                    onClick: () => toggleClientMute(userdata),
                    icon: userdata.isMuted ? "volume-up" : "volume-mute"
                });
            }
            if (!CoreUiChatHistoryHelper.isOneOfCrossOperatorsChat(userdata)) {
                menu.push(...[
                    {
                        isDivider: true
                    },
                    {
                        text: __('Пометить непрочитанным'),
                        onClick: () => markClientAsUnreaded(userdata),
                        icon: "circle"
                    },
                    {
                        text: __('Посмотреть без прочтения'),
                        onClick: () => openPreviewDialog(userdata),
                        icon: "arrow-up-right-from-square"
                    },
                    {
                        text: __('Пометить как Offline'),
                        onClick: () => openMarkAsOfflineDialog(userdata),
                        disabled: userdata.isHaveNoAnswer,
                        icon: "question-square"
                    }
                ]);
                if (!userdata.integration) {
                    menu.push({
                        text: __("Посещённые страницы"),
                        onClick: () => openAdditionalClientInfoDialog(userdata, true),
                        icon: "info-square"
                    })
                }
            }

            if (props.anotherOperatorBuddyList) {
                if (OperatorAccountStore.data.value.accessRights.canCloseOtherOperatorsChat) {
                    menu.push(...[
                        {
                            isDivider: true
                        },
                        {
                            text: __("Закрыть у выбранных операторов"),
                            onClick: async () => {
                                let operatorIds = props.anotherOperatorBuddyList.selectedOperatorIds ?? [];
                                if (!operatorIds.length) {
                                    operatorIds = OperatorAccountStore.data.value.operators.map(operator => operator.id);
                                }
                                let result = await OperatorApplicationBuddyList.removeClients([userdata.username], operatorIds);
                                if (result.isSuccess) {
                                    props.anotherOperatorBuddyList.reload();
                                }
                            },
                            icon: "times"
                        }
                    ])
                }
            }
            if (props.buddyList.isMainBuddyList && !userdata.isPinned) {
                menu.push(...[
                    {
                        isDivider: true,
                    },
                    {
                        text: __("Закрыть"),
                        onClick: async () => {
                            OperatorApplicationBuddyList.removeClientWithConfirmation(props.username);
                        },
                        icon: "times"
                    }
                ]);
            }
            contextMenuRef.value.openMenu(props.event, menu);
        }
    }
}

onMounted(() => {
    openContextMenu();
});

watch(computed(() => visible.value ? props.username : null), () => {
    nextTick(() => {
        openContextMenu();
    });
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(visible))
      ? (_openBlock(), _createBlock(ContextMenu, {
          key: 0,
          ref_key: "contextMenuRef",
          ref: contextMenuRef,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) //@ts-ignore
 ? visible.value = false : visible = false))
        }, null, 512))
      : _createCommentVNode("", true),
    (_unref(markAsOfflineDialog)?.visible)
      ? (_openBlock(), _createBlock(OperatorApplicationMarkClientAsHaveNoAnswerDialog, {
          key: 1,
          userdata: _unref(markAsOfflineDialog).client,
          visible: _unref(markAsOfflineDialog).visible,
          "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(markAsOfflineDialog).visible) = $event))
        }, null, 8, ["userdata", "visible"]))
      : _createCommentVNode("", true),
    (_unref(previewDialog)?.visible)
      ? (_openBlock(), _createBlock(OperatorClientHistoryPreviewDialog, {
          key: 2,
          userdata: _unref(previewDialog).client,
          visible: _unref(previewDialog).visible,
          "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_unref(previewDialog).visible) = $event))
        }, null, 8, ["userdata", "visible"]))
      : _createCommentVNode("", true),
    (_unref(clientInfoDialog)?.visible)
      ? (_openBlock(), _createBlock(AdditionalClientInfoDialog, {
          key: 3,
          userdata: _unref(clientInfoDialog).client,
          visible: _unref(clientInfoDialog).visible,
          "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_unref(clientInfoDialog).visible) = $event)),
          "default-tab-id": _unref(clientInfoDialog).pages ? 'pages' : undefined
        }, null, 8, ["userdata", "visible", "default-tab-id"]))
      : _createCommentVNode("", true)
  ]))
}
}

})